import React from "react";
import { Link } from "react-router-dom";
import { FaBriefcase, FaFileArchive, FaFileSignature } from "react-icons/fa";

const LetterBanner = () => {
  return (
    <div className="relative mt-40 text-white py-12 px-6 md:px-10 lg:px-16">
      <div className="absolute inset-0 bg-black opacity-20"></div>
      <div className="relative z-10 max-w-7xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 animate-fade-in">
          Streamline Your Hiring Process
        </h2>
        <p className="text-lg md:text-xl mb-8 max-w-3xl mx-auto animate-fade-in-delay">
          Effortlessly send professional employment letters to candidates. Create customized offer letters or confirm permanent positions with just a few clicks, ensuring a seamless onboarding experience.
        </p>
        <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-6">
          <button className="flex items-center justify-center bg-green-600 hover:bg-e-ride-purple text-white font-semibold py-4 px-8 rounded-lg shadow-md hover:shadow-xl transform hover:scale-105 transition-all duration-300">
            <FaBriefcase className="mr-2" />
            <Link to="/employmentofferEditor">
              Send Employment Offer Letter
            </Link>
          </button>
          <button className="flex items-center justify-center bg-blue-600 hover:bg-e-ride-purple text-white font-semibold py-4 px-8 rounded-lg shadow-md hover:shadow-xl transform hover:scale-105 transition-all duration-300">
            <FaFileSignature className="mr-2" />
            <Link to="/permanentLetter">
              Send Permanent Letter
            </Link>
          </button>
          <button className="flex items-center justify-center bg-orange-600 hover:bg-e-ride-purple text-white font-semibold py-4 px-8 rounded-lg shadow-md hover:shadow-xl transform hover:scale-105 transition-all duration-300">
            <FaFileArchive className="mr-2" />
            <Link to="/personaldetails">
              Bio-Data Form
            </Link>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LetterBanner;